// extracted by mini-css-extract-plugin
export var accordion = "_d0-0";
export var chevron = "_d0-3";
export var closed = "_d0-2";
export var content = "_d0-4";
export var open = "_d0-1";
export var rotate = "_d0-5";